import { render } from "@/components/pages/dataRecollection/customize/CustomizePage.html?vue&type=template&id=477ccefe&external"
import script from "@/components/pages/dataRecollection/customize/CustomizePage.js?vue&type=script&lang=js&external"
export * from "@/components/pages/dataRecollection/customize/CustomizePage.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__